// src/components/notifications/NotificationPermission.tsx
import React from 'react';
import { useFCM } from '../../hooks/useFCM';
import {
  BellAlertIcon,
  BellSlashIcon,
} from '@heroicons/react/24/outline';
import toast from 'react-hot-toast';

const NotificationPermission: React.FC = () => {
  const {
    loading,
    requestPermission,
    isGranted,
    isDenied,
    isDefault,
  } = useFCM();

  if (isGranted) {
    // إخفاء المكون بالكامل بعد التفعيل
    return null;
  }

  if (isDenied) {
    return (
      <div className='bg-red-50 border border-red-200 rounded-lg p-4 mb-6'>
        <div className='flex items-start gap-3'>
          <BellSlashIcon className='h-6 w-6 text-red-600 flex-shrink-0 mt-0.5' />
          <div className='flex-1'>
            <h3 className='text-sm font-semibold text-red-900 mb-1'>
              الإشعارات محظورة
            </h3>
            <p className='text-sm text-red-700 mb-2'>
              لقد رفضت إذن الإشعارات. لتفعيل الإشعارات، يرجى تغيير الإعدادات في
              المتصفح.
            </p>
            <button
              onClick={() => {
                toast(
                  'يرجى الذهاب إلى إعدادات المتصفح > الخصوصية والأمان > إعدادات الموقع > الإشعارات'
                );
              }}
              className='text-sm text-red-800 hover:text-red-900 font-medium underline'
            >
              كيفية تفعيل الإشعارات
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (isDefault) {
    return (
      <div className='bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6'>
        <div className='flex items-start gap-3'>
          <BellAlertIcon className='h-6 w-6 text-blue-600 flex-shrink-0 mt-0.5' />
          <div className='flex-1'>
            <h3 className='text-sm font-semibold text-blue-900 mb-1'>
              فعّل الإشعارات الفورية
            </h3>
            <p className='text-sm text-blue-700 mb-3'>
              احصل على إشعارات فورية عن الواجبات، الدرجات، الحصص الجديدة،
              والمدفوعات مباشرة على جهازك.
            </p>
            <button
              onClick={requestPermission}
              disabled={loading}
              className='px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors'
            >
              {loading ? 'جاري التفعيل...' : 'تفعيل الإشعارات'}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default NotificationPermission;
